import { render, staticRenderFns } from "./Papers.vue?vue&type=template&id=4266f3e5&scoped=true&"
import script from "./Papers.vue?vue&type=script&lang=js&"
export * from "./Papers.vue?vue&type=script&lang=js&"
import style0 from "./Papers.vue?vue&type=style&index=0&id=4266f3e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4266f3e5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4266f3e5')) {
      api.createRecord('4266f3e5', component.options)
    } else {
      api.reload('4266f3e5', component.options)
    }
    module.hot.accept("./Papers.vue?vue&type=template&id=4266f3e5&scoped=true&", function () {
      api.rerender('4266f3e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/Papers.vue"
export default component.exports